import { useEffect, useState } from 'react';
import API from '../../../../../services/api';

let cache = null;
let promesaEnCurso = null;

export default function useRutas() {
  const [rutas, setRutas] = useState(cache ?? []);
  const [cargando, setCargando] = useState(!cache);

  useEffect(() => {
    if (cache) return;

    promesaEnCurso = promesaEnCurso ?? API.get('/rutas')
      .then(res => {
        cache = res.data?.rutas ?? [];
        return cache;
      })
      .catch(() => {
        cache = [];
        return cache;
      });

    let activo = true;
    promesaEnCurso.then(data => {
      if (activo) {
        setRutas(data);
        setCargando(false);
      }
    });
    return () => { activo = false; };
  }, []);

  return { rutas, cargando };
}